import gql from 'graphql-tag'
export default gql`mutation updateSieveSizeMutation($sieveSizeId: Int!, $sieveSize: BaseSieveSize!) {
  updateSieveSize(sieveSizeId: $sieveSizeId, sieveSize: $sieveSize) {
    code
    size
    id
  }
}`